import type { IAddDocumentsPageProps } from './index';
import type { IAddDocumentsPageStateProps } from './useAddDocuments';

import React from 'react';

import { FIELD_NAMES } from './formConfig';

import StudentQuestion from '$/components/blocks/StudentQuestion';
import BorderBottomSpan from '$/components/elements/BorderBottomSpan';
import Button from '$/components/elements/Button';
import ButtonContainer from '$/components/elements/ButtonContainer';
import Container from '$/components/elements/Container';
import Divider from '$/components/elements/Divider';
import Loader from '$/components/elements/Loader';
import ResponsiveFileInputQuestion from '$/components/elements/Questions/ResponsiveFileInputQuestion';
import { H4Typography, Sub1Typography } from '$/components/elements/Typography';

interface IAddDocumentsPageViewProps
  extends IAddDocumentsPageProps,
    IAddDocumentsPageStateProps {}

const AddDocuments = (props: IAddDocumentsPageViewProps) => {
  return (
    <StudentQuestion noLimitHeight>
      <form
        onSubmit={props.form.handleSubmit((variables) =>
          props.submitMutation.mutateAsync(variables)
        )}
      >
        <StudentQuestion.Section>
          <Container>
            <H4Typography bold as="h2" color="grey7">
              <BorderBottomSpan>Dokumente</BorderBottomSpan>
              <span> hinzufügen</span>
            </H4Typography>
          </Container>
        </StudentQuestion.Section>
        <Container
          style={{
            paddingBottom: '1rem',
          }}
        >
          <Sub1Typography as="h1">
            Um dein Semester-Update abzuschließen, musst du noch folgende
            Dokumente hochladen.
          </Sub1Typography>
        </Container>
        <Container>
          <ResponsiveFileInputQuestion
            title="Leistungsnachweise"
            control={props.form.control}
            name={FIELD_NAMES.CERTIFICATES_OF_ACHIEVEMENT}
            max={3}
          />
          <ResponsiveFileInputQuestion
            title="Immatrikulationsbescheinigung"
            control={props.form.control}
            name={FIELD_NAMES.CERTIFICATES_OF_ENROLLMENT}
            max={3}
          />
          <Divider />
          <StudentQuestion.Section>
            <Sub1Typography as="h2" color="grey7">
              OPTIONAL
            </Sub1Typography>
          </StudentQuestion.Section>
          <ResponsiveFileInputQuestion
            title="Sonstiges"
            control={props.form.control}
            name={FIELD_NAMES.OTHER_DOCUMENTS}
            max={3}
          />
          <Divider />
          <ButtonContainer
            columns="1fr"
            rowGap="8px"
            style={{ marginTop: '64px' }}
          >
            <Button
              buttonProps={{
                as: 'button',
                type: 'submit',
              }}
              title="Senden"
              loader={<Loader />}
              isLoading={props.submitMutation.isLoading}
              disabled={!props.form.formState.isValid}
            />
          </ButtonContainer>
        </Container>
      </form>
    </StudentQuestion>
  );
};

export default AddDocuments;
